import Migas from "../migasGeomedellin/Migas";
import { Container, Form } from "react-bootstrap";
import PiePagina from "../piePagina/PiePagina";
import IconButton from "../../common/IconButton";
import { useEffect, useContext, useState, useRef } from "react";
import contextGeomedellin from "../../../context/contextGeomedellin";
import OpenModal from "../admin/OpenModal";

// services (http request)
import getDatos from "../../../services/getDatos";
import cambiarEstado from "../../../services/cambiarEstado";
import setDatos from "../../../services/setDatos";

//componentes
import { UploadFileIcon } from "../../common/UploadFileIcon";
import { AccordionGeo } from "../../common/AccordionGeo";
import { AdminVideo } from "../admin/forms/Ayudas/AdminVideo";
import { AdminManual } from "../admin/forms/Ayudas/AdminManual";
import { Player } from "../../common/Player";
import Load from "../../common/Load";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

// variables de entorno
import { URL_IMAGE_GEOMEDELLIN } from "../../../environment";

//custom hooks
import { usePermisions } from "../../../hooks/usePermisions";

// icons
import { MdOutlineModeEdit } from "react-icons/md";
import { AdminPregunta } from "../admin/forms/Ayudas/AdminPregunta";
import guardarUbicacion from "../../../services/guardarUbicacion";
import getIp from "../../../services/getIP";

export default function Ayudas({
  idComponente,
  caractFiltro,
  descripcion,
  imagen,
}) {
  const refFormBuzon = useRef(null);

  //contexto global geomdellin, donde se almacenan los estados globales de la aplicación
  const { componentes, restablecerEstilos } = useContext(contextGeomedellin);

  // Estado object editar
  const [objectEditar, setObjectEditar] = useState(null);

  // Estado modal
  // Estado modal
  const [show, setShow] = useState(false);

  const [flag, setFlag] = useState(false);
  // Estado para validar que modal abrio
  const [typeOpenAdmin, setTypeOpenAdmin] = useState(false);

  const [dataBuzon, setDataBuzon] = useState({
    correo: "",
    sugerencia: "",
    reaccion: null,
  });

  const [ayudasData, setAyudasData] = useState({
    videos: [],
    manuales: [],
    preguntas: [],
  });

  const [reacciones, setReacciones] = useState([]);

  const [load, setLoad] = useState(false);

  // Abrir modal
  const handleShow = () => setShow(true);

  // Cerrar modal
  const handleClose = () => {
    setShow(false);
  };

  const handleChangeBuzon = ({ target }) => {
    setDataBuzon({
      ...dataBuzon,
      [target.name]: target.value,
    });
  };

  const handleClickReaccion = ({ target }) => {
    setDataBuzon({
      ...dataBuzon,
      reaccion: target.value,
    });
  };

  const getAyudas = async () => {
    try {
      setLoad(true);
      const responseAyudas = await getDatos("geomed/ayudas");
      setAyudasData(responseAyudas);
    } catch (err) {
      alert("Error al cargar las ayudas");
    } finally {
      setLoad(false);
    }
  };

  const getReacciones = async () => {
    const responseReacciones = await getDatos("atributos/reacciones");
    setReacciones(responseReacciones);
  };

  const eliminar = async (id, data = {}) => {
    try {
      if (window.confirm("Desea eliminar?")) {
        setLoad(true);
        await cambiarEstado(`geomed/ayudas/${id}`, data);
        alert("Se elimino correctamente");
        await getAyudas();
      } else {
        alert("cancelo la eliminacion");
      }
    } catch (error) {
      alert("Error al eliminar");
    } finally {
      setLoad(false);
    }
  };

  const saveBuzon = async () => {
    const { sugerencia, correo, reaccion } = dataBuzon;

    const isValidEmail =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!sugerencia || !correo) {
      alert("Los campos marcados con * son obligatorios");

      return;
    }

    if (!reaccion) {
      alert("Presione alguna reaccion");

      return;
    }

    if (!isValidEmail.test(correo)) {
      alert("Ingresa un correo valido");

      return;
    }

    setLoad(true);

    try {
      let jsonIp = await getIp();
      let copyDataBuzon = { ...dataBuzon };
      copyDataBuzon.location = JSON.stringify(jsonIp);
      await setDatos("geomed/buzon", copyDataBuzon);
      await setDatos("geomed/buzon/correo", {
        ...dataBuzon,
        nombreReaccion: reacciones.find(
          (reaccion) =>
            Number(reaccion.id_reaccion) === Number(dataBuzon.reaccion)
        ).nombre,
      });
      alert("Sugerencia enviada y guardada exitosamente");
      refFormBuzon.current.reset();
      setFlag(false);
      setDataBuzon({
        correo: "",
        sugerencia: "",
        reaccion: null,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoad(false);
    }
  };

  const { permissions } = usePermisions(idComponente);

  useEffect(() => {
    window.scroll(0, 0);
    getAyudas();
    restablecerEstilos();
    getReacciones();
  }, []);

  return (
    <>
      <Container className="content-ayudas" fluid={true}>
        <div
          className="icon-ayuda"
          style={{
            backgroundImage: `url("${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Banner/${idComponente}/${imagen}")`,
          }}
        >
          {permissions.superAdmin ? (
            <div className="edit-banner">
              <UploadFileIcon
                icon={<MdOutlineModeEdit color="#fff" size={"20px"} />}
                idComponente={idComponente}
              />
            </div>
          ) : null}
          <div className="content-degradado">
            <div className="content-contendido-img-banner">
              <label className="lblitulo-txt-imgbanner">Ayudas</label>
              <p>
                <label className="lbdescripcion-txt-imgbanner">
                  {descripcion}
                </label>
              </p>
            </div>
          </div>
          <label className="color-borde-img-banner"></label>
        </div>
        <Migas ruta="Ayudas" />
        <div className="content-barra-vtutoriales mt-3">
          <div className="content-hijo-ayuda">
            <div>
              <div className="container-ayudas-btn">
                <div>
                  <label className="lbl-primario-barra-ayuda">Video</label>
                  <label className="lbl-secundario-barra-ayuda">
                    tutoriales
                  </label>
                </div>
                <div>
                  {permissions.admin || permissions.superAdmin ? (
                    <OpenModal
                      componentes={componentes}
                      idComponente={idComponente}
                      caractFiltro={caractFiltro}
                      tituloAdmin={"Nuevo Video"}
                      ayudasGet={getAyudas}
                      setLoad={setLoad}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="border-barra-ayudas">
                <label className="video-tutoriales-barra-bold"></label>
              </div>
            </div>
            <label className="label-ayuda-descripcion">
              Aprende a usar GeoMedellín consultado los videotutoriales que te
              mostrarán de manera interactiva el uso de distintos elementos del
              geoportal
            </label>

            <div className="mt-3 content-hijo-fila-documentos-ayuda">
              <Swiper
                navigation={true}
                modules={[Navigation]}
                slidesPerView={
                  ayudasData?.videos?.length < 4
                    ? ayudasData?.videos?.length
                    : 4
                }
                className="mySwiper"
                spaceBetween={5}
                style={{
                  "--swiper-navigation-size": "25px",
                }}
                breakpoints={{
                  200: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                  },
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 50,
                  },
                  600: {
                    slidesPerView: 1,
                    spaceBetween: 50,
                  },
                  1000: {
                    slidesPerView:
                      ayudasData?.videos?.length < 4
                        ? ayudasData?.videos?.length
                        : 4,
                    spaceBetween: 5,
                  },
                }}
              >
                {ayudasData.videos.map((video) => (
                  <SwiperSlide key={video.id_ayuda}>
                    <div
                      className="tarjeta-video-tutorial hover-tajetas-ayudas"
                      key={video.id_ayuda}
                    >
                      <div className="icon-center-ayudas color-play">
                        <Player
                          handleClick={async () => {
                            await guardarUbicacion("4", "2", video.id_ayuda);
                          }}
                          key={video.id_ayuda}
                          {...video}
                          componente={componentes.find(
                            (comp) => comp?.id_componente === idComponente
                          )}
                          classDivVideo={"icon-center-ayudas color-play"}
                          classVideo={
                            "icon-center-ayudas color-play video-image"
                          }
                        />
                        {permissions.admin || permissions.superAdmin ? (
                          <div className="content-opciones-card-ayudas">
                            {permissions.admin || permissions.superAdmin ? (
                              <div
                                className="editar"
                                title="Editar"
                                onClick={() => {
                                  handleShow();
                                  setTypeOpenAdmin("Video");
                                  setObjectEditar(video);
                                }}
                              >
                                <IconButton className="icon-editar" />
                              </div>
                            ) : (
                              ""
                            )}
                            {permissions.superAdmin ? (
                              <div
                                className="eliminar"
                                title="Eliminar"
                                onClick={async () =>
                                  await eliminar(video.id_ayuda, {
                                    estado: false,
                                  })
                                }
                              >
                                <IconButton className="icon-eliminar" />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="mt-2">
                        <label className="lbl-card-titulo-ayudas">
                          {video.nombre}
                        </label>
                        <label className="lbl-card-descripcion-ayudas mt-2">
                          {video.descripcion}
                        </label>
                      </div>
                      <div className="flex-direction-hr">
                        <hr className="hr-propiedades-ayudas" />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
        <div className="content-barra-vtutoriales mt-5">
          <div className="content-hijo-ayuda">
            <div>
              <div className="container-ayudas-btn">
                <div>
                  <label className="lbl-primario-barra-ayuda">Manuales</label>
                  <label className="lbl-secundario-barra-ayuda">
                    de usuario
                  </label>
                </div>
                <div>
                  {permissions.admin || permissions.superAdmin ? (
                    <OpenModal
                      componentes={componentes}
                      idComponente={idComponente}
                      caractFiltro={caractFiltro}
                      tituloAdmin={"Nuevo Manual"}
                      ayudasGet={getAyudas}
                      setLoad={setLoad}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="border-barra-ayudas">
                <label className="border-bold-barra"></label>
              </div>
            </div>
            <label className="label-ayuda-descripcion">
              Explora los manuales disponibles para orientarte mejor en la
              navegación por GeoMedellín
            </label>

            <div className="content-hijo-fila-documentos-ayuda">
              <Swiper
                navigation={true}
                modules={[Navigation]}
                slidesPerView={
                  ayudasData?.manuales?.length < 4
                    ? ayudasData?.manuales?.length
                    : 3
                }
                className="mySwiper"
                spaceBetween={5}
                style={{
                  "--swiper-navigation-size": "25px",
                }}
                breakpoints={{
                  200: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                  },
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 50,
                  },
                  600: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                  },
                  1000: {
                    slidesPerView:
                      ayudasData?.manuales?.length < 4
                        ? ayudasData?.manuales?.length
                        : 3,
                    spaceBetween: 5,
                  },
                }}
              >
                {ayudasData.manuales.map((manual) => (
                  <SwiperSlide key={manual.id_ayuda}>
                    <div className="tarjeta-video-tutorial hover-tajetas-ayudas">
                      <div className="icon-center-ayudas">
                        <div className="img-log-pdf">
                          <a
                            href={`${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Ayudas/${manual.id_ayuda}/${manual.archivo}`}
                            target={"_blank"}
                            rel={"noreferrer"}
                            download
                            onClick={async () => {
                              await guardarUbicacion("4", "2", manual.id_ayuda);
                            }}
                          >
                            <img
                              className="img-log-pdf"
                              src={`${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Iconos/${
                                manual.archivo?.split(".")[1]
                              }.png`}
                              alt={manual.archivo}
                            />
                          </a>
                        </div>
                        {permissions.admin || permissions.superAdmin ? (
                          <div className="content-opciones-card-ayudas-manual">
                            {permissions.admin || permissions.superAdmin ? (
                              <div
                                className="editar"
                                title="Editar"
                                onClick={() => {
                                  handleShow();
                                  setTypeOpenAdmin("Manual");
                                  setObjectEditar(manual);
                                }}
                              >
                                <IconButton className="icon-editar" />
                              </div>
                            ) : (
                              ""
                            )}
                            {permissions.superAdmin ? (
                              <div
                                className="eliminar"
                                title="Eliminar"
                                onClick={() => {
                                  eliminar(manual.id_ayuda, { estado: false });
                                }}
                              >
                                <IconButton className="icon-eliminar" />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div>
                        <label className="lbl-titulo-ayudas">
                          {manual.nombre}
                        </label>
                        <label className="lbl-card-descripcion-ayudas mt-1">
                          {manual.descripcion}
                        </label>
                      </div>
                      <div className="flex-direction-hr">
                        <hr className="hr-propiedades-ayudas" />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
        <div className="content-barra-vtutoriales mt-5">
          <div className="content-hijo-ayuda">
            <div>
              <label className="lbl-reacccion-titlo">Buzón</label>
              <label className="lbl-secundario-barra-ayuda">
                de sugerencias
              </label>
              <div className="border-barra-ayudas">
                <label className="preguntas-frecuentes-barra-bold"></label>
              </div>
            </div>
            <label className="lbl-reaccion mt-4">
              Queremos conocer tu opinión. Califica tu experiencia en el
              geoportal y ayúdanos a mejorar
            </label>
            <div className="flex-form-reaccion mt-4">
              <div className="tamano-form">
                <label className="lbl-reaccion-formulario">
                  ¿Qué tan satisfecho estás con nuestro portal?
                </label>
                <div className="flex-reactions-icon mt-3">
                  {reacciones.map((reaccion, index) => (
                    <div
                      className={`reaction-normal ${
                        index === flag && "reactionated"
                      }`}
                      onClick={(e) => {
                        setFlag(index);
                        handleClickReaccion(e);
                      }}
                      id={reaccion.id_reaccion}
                      key={reaccion.id_reaccion}
                    >
                      <IconButton
                        className="rection2"
                        imagen={
                          reaccion.imagen
                            ? `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Reaccion/${reaccion.id_reaccion}/${reaccion.imagen}`
                            : `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Reaccion/default.svg`
                        }
                        value={reaccion.id_reaccion}
                      />
                      <label className="lbl-reaction-icon">
                        {reaccion.nombre}
                      </label>
                    </div>
                  ))}
                </div>
                <Form ref={refFormBuzon}>
                  <Form.Group className="mt-4">
                    <Form.Label className="lbl-reaccion-formulario">
                      ¿Cuál es tu correo electrónico? <strong>*</strong>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="inputs-forms-admin focus-admin-register"
                      name="correo"
                      onChange={handleChangeBuzon}
                    />
                  </Form.Group>
                  <Form.Group className="mt-4">
                    <Form.Label className="lbl-reaccion-formulario">
                      ¿ Cuál es tu sugerencia ? <strong>*</strong>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      className="tmano-desripcion-reaccion inputs-forms-admin focus-admin-register textarea-form-admin"
                      name="sugerencia"
                      onChange={handleChangeBuzon}
                    />
                  </Form.Group>
                  <div className="button-reacciones mt-2">
                    <button
                      type="button"
                      className="btn-enviar-reaccion btn-ira-tarjeta-destacados btn btn-primary"
                      onClick={saveBuzon}
                    >
                      ENVIAR
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div className="content-barra-vtutoriales mt-5">
          <div className="content-hijo-ayuda">
            <div>
              <div className="container-ayudas-btn">
                <div>
                  <label className="lbl-primario-barra-ayuda">Preguntas</label>
                  <label className="lbl-secundario-barra-ayuda">
                    frecuentes
                  </label>
                </div>
                <div>
                  {permissions.admin || permissions.superAdmin ? (
                    <OpenModal
                      componentes={componentes}
                      idComponente={idComponente}
                      caractFiltro={caractFiltro}
                      tituloAdmin={"Nueva Pregunta"}
                      ayudasGet={getAyudas}
                      setLoad={setLoad}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="border-barra-ayudas">
                <label className="border-bold-barra"></label>
              </div>
            </div>
            <label className="label-ayuda-descripcion">
              Encuentra aquí las preguntas y respuestas más habituales que
              suelen hacerse los usuarios entorno al geoportal
            </label>
            {ayudasData.preguntas.map((pregunta, index) => (
              <div
                className={
                  index === 0
                    ? "hover-tajetas-ayudas mt-5"
                    : "hover-tajetas-ayudas mt-3"
                }
              >
                {permissions.admin || permissions.superAdmin ? (
                  <div className="content-opciones-card-ayudas-preguntas">
                    {permissions.admin || permissions.superAdmin ? (
                      <div
                        className="editar"
                        title="Editar"
                        onClick={() => {
                          handleShow();
                          setTypeOpenAdmin("Pregunta");
                          setObjectEditar(pregunta);
                        }}
                      >
                        <IconButton className="icon-editar" />
                      </div>
                    ) : (
                      ""
                    )}
                    {permissions.superAdmin ? (
                      <div
                        className="eliminar"
                        title="Eliminar"
                        onClick={() => {
                          eliminar(pregunta.id_ayuda, { estado: false });
                        }}
                      >
                        <IconButton className="icon-eliminar" />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
                <AccordionGeo {...pregunta} />
              </div>
            ))}
          </div>
        </div>
      </Container>
      <PiePagina fluid={true} />

      {typeOpenAdmin === "Video" ? (
        <AdminVideo
          caractFiltro={caractFiltro}
          idComponente={idComponente}
          show={typeOpenAdmin === "Video" ? show : false}
          onHide={() => handleClose()}
          tituloModal={"Editar Video"}
          accion={"Editar"}
          listAyudas={getAyudas}
          objectEditarVid={objectEditar}
          setLoad={setLoad}
        />
      ) : typeOpenAdmin === "Manual" ? (
        <AdminManual
          caractFiltro={caractFiltro}
          idComponente={idComponente}
          show={typeOpenAdmin === "Manual" ? show : false}
          onHide={() => handleClose()}
          tituloModal={"Editar Manual"}
          accion={"Editar"}
          listAyudas={getAyudas}
          objectEditarMan={objectEditar}
          setLoad={setLoad}
        />
      ) : typeOpenAdmin === "Pregunta" ? (
        <AdminPregunta
          caractFiltro={caractFiltro}
          idComponente={idComponente}
          show={typeOpenAdmin === "Pregunta" ? show : false}
          onHide={() => handleClose()}
          tituloModal={"Editar Pregunta"}
          accion={"Editar"}
          listAyudas={getAyudas}
          objectEditarPregunta={objectEditar}
          setLoad={setLoad}
        />
      ) : (
        ""
      )}

      <Load visible={load} />
    </>
  );
}
